import './video.css';

import base from '../base/base';
import header from '../base/header';
import threeThings from '../../components/threethings/threethings';
import SocialBarLoader from '../../components/SocialBar/SocialBarLoader';
import TrackingUtils from "../../components/fsUtils/TrackingUtils";
import videoUtils from '../../components/fsUtils/videoUtils';


new SocialBarLoader();
// FSCOM-12270 - set "More Videos" link parse.ly tracking 
TrackingUtils.setLinkTracking(document.querySelectorAll('.more-video > a.fs-more-btn'),'parsely',{
    'utm_campaign'  : 'more_videos',
    'utm_medium'    : 'fscom',
    'utm_content'   : 'morelink'
});
TrackingUtils.setLinkTracking(document.querySelectorAll('.fs-more-content > .fs-card-container > .fs-card'),'parsely',{
    'utm_campaign'  : 'more_videos',
    'utm_medium'    : 'fscom',
    'utm_content'   : 'gallerytile'
});
videoUtils.setVideoDetailsToggle();
